'use client';

import React, { useState, type ReactNode } from 'react';
import { createSafeContext } from '@skin-seoul/utils';
type SelectedProductId = {
  recentlyViewedProductId?: number;
  recommendationProductId?: number;
};
type FilterType = 'moreReviews' | 'lowerPrice';
type ProductCompareContextValue = {
  selectedProductId: SelectedProductId;
  setSelectedProductId: React.Dispatch<React.SetStateAction<SelectedProductId>>;
  selectedFilter?: FilterType;
  setSelectedFilter: React.Dispatch<React.SetStateAction<FilterType | undefined>>;
  currentProductId?: number;
};
const [ProductCompareContextProvider, useProductCompareContext] = createSafeContext<ProductCompareContextValue>('ProductCompareContext');
export { useProductCompareContext };
export type { FilterType };
type ProductCompareProviderProps = {
  children: ReactNode;
  currentProductId?: number;
};
export const ProductCompareProvider = ({
  children,
  currentProductId
}: ProductCompareProviderProps) => {
  const [selectedProductId, setSelectedProductId] = useState<SelectedProductId>({
    recentlyViewedProductId: undefined,
    recommendationProductId: undefined
  });
  const [selectedFilter, setSelectedFilter] = useState<FilterType | undefined>(undefined);
  const value: ProductCompareContextValue = {
    selectedProductId,
    setSelectedProductId,
    selectedFilter,
    setSelectedFilter,
    currentProductId
  };
  return <ProductCompareContextProvider value={value} data-sentry-element="ProductCompareContextProvider" data-sentry-component="ProductCompareProvider" data-sentry-source-file="ProductCompareContext.tsx">{children}</ProductCompareContextProvider>;
};